import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../api/client';

export default function PulseWidget({ onViewInsights }) {
  const [pulse, setPulse]     = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPulse = useCallback(async () => {
    try {
      const res = await api('/api/pulse');
      if (res.ok) setPulse(await res.json());
    } catch (_) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPulse();
    const id = setInterval(fetchPulse, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [fetchPulse]);

  if (loading) {
    return (
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #35454C', padding: '14px 16px', boxShadow: '0 2px 12px rgba(12,45,72,0.07)' }}>
        <p style={{ margin: 0, color: '#ccc', fontSize: 13 }}>💓 Computing pulse…</p>
      </div>
    );
  }

  if (!pulse) return null;

  return (
    <div style={{
      background: '#fff', borderRadius: 14, border: '1px solid #35454C',
      padding: '14px 16px', boxShadow: '0 2px 12px rgba(12,45,72,0.07)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 9, height: 9, borderRadius: '50%', background: pulse.colour, flexShrink: 0 }} />
          <span style={{ fontSize: 13, fontWeight: 700, color: '#222' }}>💓 Workload</span>
          <span style={{
            fontSize: 11, padding: '2px 8px', borderRadius: 20,
            background: pulse.colour + '22', color: pulse.colour, fontWeight: 700,
          }}>{pulse.label}</span>
        </div>
        {onViewInsights && (
          <button
            onClick={onViewInsights}
            style={{ fontSize: 12, color: '#888', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0 }}
          >View Insights →</button>
        )}
      </div>
      <p style={{ margin: '0 0 10px', fontSize: 13, color: '#555', lineHeight: 1.4 }}>{pulse.summary}</p>
      {pulse.factors && (
        <div style={{ display: 'flex', gap: 18 }}>
          {[
            { label: 'Tasks due',  value: pulse.factors.taskCount    },
            { label: 'Overdue',    value: pulse.factors.overdueCount },
            { label: 'Meetings',   value: pulse.factors.meetingCount },
          ].map(({ label, value }) => (
            <div key={label}>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#222' }}>{value}</span>
              <span style={{ fontSize: 11, color: '#aaa', marginLeft: 4 }}>{label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
